function updateVariant() {
  var no_match;
  var firstOption = $('.hidden-select option[value=' + $('.hidden-select').val() + ']').data('option1');
  if ($('.more-options-available').length) {
    var secondOption = $('.hidden-select option[value=' + $('.hidden-select').val() + ']').data('option2');
    $('.select-more-options option[data-value=' + secondOption + ']').attr('selected', 'selected');
  }

  $('.list-radios-material input[value=' + firstOption + ']').prop('checked', true);

  $('.radio-holder input').on('change', function() {
    no_match = true;
    var $this = $(this);
    var alt = $this
      .val()
      .toLowerCase()
      .replace(' ', '-');
    firstOption = alt;

    changeImages(2, 1, 1, alt);

    if ($('.more-options-available').length) {
      var sizeVal;
      $('.select-more-options option').each(function() {
        if ($(this).attr('selected', 'selected')) {
          sizeVal = $(this).data('value');
        }
      });
      $('.hidden-select option[data-option1=' + alt + ']').each(function() {
        if ($(this).data('option2') == sizeVal) {
          $(this)
            .attr('selected', 'selected')
            .siblings()
            .removeAttr('selected');
          $('.product-single__variants').trigger('change');
          no_match = false;
          $('.btn--main').removeClass('disabled');
        }
      });

      if (no_match) {
        $('.btn--main').addClass('disabled');
      }
    } else {
      $('.hidden-select option').each(function() {
        let current = $(this).data('option1');
        if (current == alt) {
          $(this)
            .attr('selected', 'selected')
            .siblings()
            .removeAttr('selected');
          $('.product-single__variants').trigger('change');
          no_match = false;
          $('.btn--main').removeClass('disabled');
        }
      });

      if (no_match) {
        $('.btn--main').addClass('disabled');
      }
    }
  });

  if ($('.more-options-available').length) {
    $('.select-more-options').on('change', function() {
      no_match = true;
      let materialVal = firstOption;
      let selectedValue = $(this)
        .find('option:selected')
        .data('value');
      let grabSelected = $(this).find('option:selected');
      grabSelected
        .attr('selected', 'selected')
        .siblings()
        .removeAttr('selected');

      $('.hidden-select option[data-option2=' + selectedValue + ']').each(function() {
        let current = $(this).data('option1');
        if (materialVal == current) {
          $(this)
            .attr('selected', 'selected')
            .siblings()
            .removeAttr('selected');
          $('.product-single__variants').trigger('change');
          no_match = false;
          $('.btn--main').removeClass('disabled');
        }
      });

      if (no_match) {
        $('.btn--main').addClass('disabled');
      }
    });
  }
}

// Change Images
function changeImages(outer, inner, nthChild, alt) {
  let windowWidth = $(window).width();
  let outerCounter = 0;
  let innerCounter = 0;
  let imagesPosition = 2;
  if (windowWidth <= 767) {
    outer = 1;
    inner = 0;
    nthChild = 2;
    imagesPosition = 1;
  }
  $('.product__images:nth-child(' + nthChild + ') .product__image').addClass('hidden');
  $('.product__images:nth-child(' + nthChild + ') .product__image').each(function() {
    let altText = $(this).data('variant');
    if (altText == alt && outerCounter < outer) {
      $(this).removeClass('hidden');
      outerCounter++;
    }
  });

  if ($('.product__images--bottom').length) {
    $('.product__images--bottom[data-position="' + imagesPosition + '"] .product__image').addClass('hidden');
    $('.product__images--bottom[data-position="' + imagesPosition + '"] .product__image').each(function() {
      let altTextInner = $(this).data('variant');
      if (altTextInner == alt) {
        if (innerCounter > inner) {
          $(this).removeClass('hidden');
        }
        innerCounter++;
      }
    });
  }
}

module.exports = {
  updateVariant
};

// select-more-options
